import React from 'react';

export default function renderAbout({ about }) {
  return about === '' ? <>coming soon!</> : about;
}
